import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone",
  templateUrl: "./med-icon-phone.component.html",
})
export class MedIconPhoneComponent extends SvgMixinComponent {}
